<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Update Partner
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2" @submit.prevent="sendCall">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="updatePartnerFirstName">First Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="updatePartnerFirstName"
                      v-model="formData.firstName"
                      v-validate="'required|min:2|max:25'"
                      name="firstName"
                      data-vv-as="first name"
                      :class="errorBag.has('firstName') ? 'is-invalid' : ''"
                      placeholder="Enter first name"
                    />
                    <small v-show="errorBag.has('firstName')" class="invalid-feedback">
                      {{ errorBag.first('firstName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="updatePartnerLastName">Last Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="updatePartnerLastName"
                      v-model="formData.lastName"
                      v-validate="'required|min:2|max:25'"
                      name="lastName"
                      data-vv-as="last name"
                      :class="errorBag.has('lastName') ? 'is-invalid' : ''"
                      placeholder="Enter last name"
                    />
                    <small v-show="errorBag.has('lastName')" class="invalid-feedback">
                      {{ errorBag.first('lastName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="updatePartnerBusinessName">Business Name <small class="text-muted">(optional)</small></label>
                    <input
                      type="text"
                      class="form-control"
                      id="updatePartnerBusinessName"
                      v-model="formData.businessName"
                      v-validate="'max:100'"
                      name="businessName"
                      data-vv-as="business name"
                      :class="errorBag.has('businessName') ? 'is-invalid' : ''"
                      placeholder="Enter business name"
                    />
                    <small v-show="errorBag.has('businessName')" class="invalid-feedback">
                      {{ errorBag.first('businessName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="updatePartnerEmail">Email <span class="text-danger">*</span></label>
                    <input
                      type="email"
                      class="form-control"
                      id="updatePartnerEmail"
                      v-model="formData.email"
                      v-validate="'required|email'"
                      name="email"
                      :class="errorBag.has('email') ? 'is-invalid' : ''"
                      placeholder="Enter email"
                    />
                    <small v-show="errorBag.has('email')" class="invalid-feedback">
                      {{ errorBag.first('email') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="updatePartnerPhoneNumber">Phone Number <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="updatePartnerPhoneNumber"
                      v-model="formData.phoneNumber"
                      v-validate="'required'"
                      name="phoneNumber"
                      data-vv-as="phone number"
                      :class="errorBag.has('phoneNumber') ? 'is-invalid' : ''"
                      placeholder="Enter phone number"
                    />
                    <small v-show="errorBag.has('phoneNumber')" class="invalid-feedback">
                      {{ errorBag.first('phoneNumber') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="updatePartnerStatus">Status <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      id="updatePartnerStatus"
                      v-model="formData.status"
                      v-validate="'required'"
                      name="status"
                      :class="errorBag.has('status') ? 'is-invalid' : ''"
                    >
                      <option :value="''" disabled>Select Status</option>
                      <option :value="1">Active</option>
                      <option :value="0">Inactive</option>
                    </select>
                    <small v-show="errorBag.has('status')" class="invalid-feedback">
                      {{ errorBag.first('status') }}
                    </small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" class="btn btn-secondary mr-1" @click="$emit('hide')" :disabled="loading">
              Cancel
            </button>
            <button type="button" class="btn btn-primary mr-1 d-flex" @click="sendCall" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
              {{ loading ? 'Updating...' : 'Update Partner' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'partner'],
  data() {
    return {
      loading: false,
      formData: this.emptyForm()
    };
  },
  methods: {
    emptyForm() {
      return {
        firstName: '',
        lastName: '',
        businessName: '',
        email: '',
        phoneNumber: '',
        status: ''
      }
    },
    fillForm() {
      let partner = this.partner || {}
      this.formData = {
        firstName: partner.first_name || '',
        lastName: partner.last_name || '',
        businessName: partner.business_name || '',
        email: partner.email || '',
        phoneNumber: partner.phone_number || '',
        status: partner.status != null ? Number(partner.status) : ''
      }
      this.$nextTick(() => {
        this.$validator.reset();
      })
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return
        }
        this.loading = true;
        let requestData = {
          partnerId: this.partner.id,
          firstName: this.formData.firstName,
          lastName: this.formData.lastName,
          businessName: this.formData.businessName,
          email: this.formData.email,
          phoneNumber: this.formData.phoneNumber,
          status: this.formData.status
        };

        this.makeRequest('post', 'v1/update-partner', requestData).then(callResponse => {
          this.loading = false;
          if (!callResponse.error && callResponse.response.data.code == 200) {
            this.$emit('partnerUpdated', callResponse.response.data.data);
            this.$emit('hide');
          }
        });
      });
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.fillForm();
      }
    }
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
}

.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  overflow-y: auto;
}
</style>
